/* This file is autogenerated by "pnpm run generateIconComponents" command */
import React from 'react';
import { SVGProps } from 'react';

const Check: React.FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}><path fill="currentColor" d="M21 6.6368c-.0431.0372-.0881.0722-.1289.1117Q15.1048 12.2642 9.3398 17.781c-.0539.0511-.0989.1108-.194.219-.0553-.0839-.0835-.1499-.1317-.1961a7519 7519 0 0 0-5.8697-5.6298c-.0446-.0426-.0961-.0785-.1444-.1176v-.0336c.501-.4794 1.0027-.9578 1.5023-1.438.0535-.0516.0957-.1136.144-.171 1.515 1.4505 3.0051 2.8773 4.5032 4.3121 3.3858-3.252 6.751-6.4843 10.1269-9.726.3905.3676.7519.71 1.1156 1.0493.2002.1871.4055.3694.608.5538z"/></svg>
);

export default Check;
